export enum PatientStatus {
    none = 0,
    active = 1,
    inActive = 2,
    merged = 3,
}
